<template>
    <div class="table-container-main">
        <div class="confirm-svg">
            <svg
                style="padding-left: 5px;"
                height="50px"
                id="Layer_2"
                data-name="Layer 2"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 156 180.36"
            >
                <g id="image">
                    <path
                        d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z"
                        style="fill: #000; fill-rule: evenodd;"
                    />
                </g>
            </svg>

            <h2>Drivers</h2>
        </div>
        <table-filter :filterByUserName="true" @filterValues="filterValues($event)"/>
        <div class="responsive-table">
            <div class="table-header" id="header">
                <div class="col-1">Driver Code</div>
                <div class="col-2">Driver Name</div>
                <div class="col-3">Email</div>
                <div class="col-4"></div>
                <div class="col-5"></div>
            </div>

            <loading-charts
                v-if="loadingTable"
                class="loading-charts"
            />

            <div class="table-row-container">
                <div
                    class="table-row"
                    v-for="(driver, index) in driverTableData"
                    :key="driver.driverCode || index"
                >
                    <div class="col-1">
                        <p
                            class="shipmentid-text"
                            id="shipmentid-text"
                            @click="getDriverDataClick(driver.driverCode)"
                        >
                            {{ driver.driverCode }}
                        </p>
                    </div>

                    <div class="col-2 col-data">
                        {{ getDriverName(driver) }}
                    </div>

                    <div class="col-3 col-data">
                        {{ driver.email }}
                    </div>

                    <div class="col-4 col-data">
                        <p
                            class="service-text"
                            :class="{
                                'active-status': driver.recordStatus,
                                'inactive-status': !driver.recordStatus
                            }"
                        >
                            {{ "" }}
                        </p>
                    </div>

                    <div class="col-5">
                        <input
                            v-if="$route.name === 'TripSheetDashboard'"
                            type="checkbox"
                            :checked="isChecked(driver.driverCode)"
                            class="select-id-checkbox"
                            @click="checkBoxSelectID(driver.driverCode, index)"
                        />

                        <input
                            v-if="$route.name === 'RouteDashboard'"
                            type="checkbox"
                            class="select-id-checkbox"
                            @click="checkBoxSelectID(driver.driverCode, index)"
                        />
                    </div>
                </div>

                <div
                    v-if="!loadingTable && driverTableData.length === 0"
                    class="table-row"
                >
                    <div class="col-1"></div>
                    <div class="col-2 col-data">No Drivers</div>
                    <div class="col-3"></div>
                    <div class="col-4"></div>
                    <div class="col-5"></div>
                </div>
            </div>
        </div>
    </div>

    <div
        v-if="$route.name !== 'UserDashboard'"
        class="button-container"
    >
        <div class="print-selected close-label">
            <p
                class="print-selected-text download-csv"
                @click="downloadDriverCSV()"
            >
                Download CSV
            </p>
        </div>
    </div>

    <alert-user
        v-if="toggleAlertBox"
        :message="alertMessage"
        @closeAlertBox="closeAlertBox"
    />

    <driver-info
        v-if="toggleDriverInfo"
        @closeDriverInfo="closeDriverInfo($event)"
        :driverCode="driverCode"
    />
</template>

<script>
import { API } from "aws-amplify";
import AlertUser from "../../../components/Popups/AlertUser.vue";
import DriverInfo from "../DriverDashboard/DriverInfo.vue"
import LoadingCharts from "../../ShipmentDashboard/LoadingCharts.vue";
import jsonexport from "jsonexport";
import TableFilter from '../TableFilter.vue'

export default {
    components: {
        AlertUser,
        LoadingCharts,
        DriverInfo,
        TableFilter
    },

    props: [
        "userData",
        "jwtToken",
        "selectedUserData"
    ],

    watch: {
        userData() {
            if (this.userData) {
                this.getDriverData();
            } else {
                this.toggleAlertBox = true;
                this.alertMessage =
                    "Unable to get user data to generate driver table.";
            }
        }
    },

    mounted() {
        // if (this.userData) {
            this.getDriverData();
        // }
    },

    data() {
        return {
            driverCode: null,
            driverTableData: [],
            loadingTable: false,
            toggleAlertBox: false,
            alertMessage: "",
            selectedIndex: null,
            toggleDriverInfo: false
        };
    },

    methods: {
        filterValues(event){
            this.isFiltered = true;
            this.filterEvent = event;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;

            switch (event.filterField) {
                case "username":
                    this.getDriverByDriverCode(event.filterValue)
                    break;
                default:
                    break;
            }
        },
        getDriverName(driver) {
            const firstName = driver?.firstName ?? "";
            const lastName = driver?.lastName ?? "";

            return `${firstName} ${lastName}`.trim() || "No Name";
        },

        closeDriverInfo(event){
            this.toggleDriverInfo = event;
            this.getDriverData();
        },

        isChecked(driverCode) {
            return this.selectedUserData?.driverCode === driverCode;
        },

        checkBoxSelectID(driverCode, index) {
            this.$emit("checkBoxSelectID", driverCode);

            this.selectedIndex = index;

            const checkboxes = document.querySelectorAll(
                ".select-id-checkbox"
            );

            checkboxes.forEach((checkbox, checkboxIndex) => {
                checkbox.checked = checkboxIndex === index;
            });
        },

        getDriverDataClick(driverCode) {
            this.driverCode = driverCode;
            this.toggleDriverInfo = true;
            console.log("GET DRIVER")
        },

        closeAlertBox(toggleAlertBox) {
            this.toggleAlertBox = toggleAlertBox;
        },

        async getDriverByDriverCode(driverCode){
            this.loadingTable = true;

            const graphqlQuery = `
                query GetDriver($driverCode: String!) {
                    getDriver(driverCode: $driverCode) {
                        driverCode
                        driverId
                        firstName
                        lastName
                        recordStatus
                        vehicleNeeded
                        isEmployee
                        allowLegacy
                        allowManifest
                        addWaypoint
                        addLocation
                        addShipment
                        defaultRoute
                        routeOverRide
                        createManifestPickup
                        allowWarehouseScan
                        email
                    }
                }
            `;

            try {
                const response = await API.graphql({
                    query: graphqlQuery,
                    variables: {
                        driverCode
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                this.driverTableData = response.data.getDriver
                    ? [response.data.getDriver]
                    : [];
            } catch (error) {
                console.error("Error getting driver:", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Error getting driver.";
                this.driverTableData = [];
            } finally {
                this.loadingTable = false;
            }
        },

        async getDriverData() {
            this.loadingTable = true;

            const graphqlQuery = `
                query ListDrivers {
                    listDrivers {
                        items {
                            driverCode
                            driverId
                            firstName
                            lastName
                            recordStatus
                            vehicleNeeded
                            isEmployee
                            allowLegacy
                            allowManifest
                            addWaypoint
                            addLocation
                            addShipment
                            defaultRoute
                            routeOverRide
                            createManifestPickup
                            allowWarehouseScan
                            email
                        }
                    }
                }
            `;

            try {
                const response = await API.graphql({
                    query: graphqlQuery,
                    authMode: "AMAZON_COGNITO_USER_POOLS"
                });

                this.driverTableData =
                    response.data.listDrivers.items
                        ?.filter(Boolean)
                        .sort((a, b) => {
                            const lastNameA = a.lastName ?? "";
                            const lastNameB = b.lastName ?? "";

                            return lastNameA.localeCompare(lastNameB);
                        }) ?? [];
            } catch (error) {
                console.error("Error getting drivers:", error);

                this.toggleAlertBox = true;
                this.alertMessage = "Error getting drivers.";
                this.driverTableData = [];
            } finally {
                this.loadingTable = false;
            }
        },

        async downloadDriverCSV() {
            this.loadingTable = true;

            const csvArray = this.driverTableData.map(driver => {
                return {
                    DriverCode: driver.driverCode,
                    DriverId: driver.driverId,
                    FirstName: driver.firstName,
                    LastName: driver.lastName,
                    Active: driver.recordStatus,
                    VehicleNeeded: driver.vehicleNeeded,
                    IsEmployee: driver.isEmployee,
                    AllowLegacy: driver.allowLegacy,
                    AllowManifest: driver.allowManifest,
                    AddWaypoint: driver.addWaypoint,
                    AddLocation: driver.addLocation,
                    AddShipment: driver.addShipment,
                    DefaultRoute: driver.defaultRoute,
                    RouteOverride: driver.routeOverRide,
                    CreateManifestPickup: driver.createManifestPickup,
                    AllowWarehouseScan: driver.allowWarehouseScan
                };
            });

            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    console.error("Error creating driver CSV:", error);

                    this.toggleAlertBox = true;
                    this.alertMessage =
                        "Error downloading driver data.";
                    this.loadingTable = false;

                    return;
                }

                const blob = new Blob([csv], {
                    type: "text/csv"
                });

                const anchor = document.createElement("a");

                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = "Drivers.csv";
                anchor.click();

                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();

                this.loadingTable = false;
            });
        }
    }
};
</script>

<style scoped>
h3 {
    margin: 0;
}

.table-container-main {
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table {
    width: 100%;
}

.confirm-svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
    margin-bottom: 5px;
}

.confirm-svg svg {
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2 {
    margin: 0;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    color: #ffffff;
}

.table-row-container {
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row {
    from {
        margin-left: -50px;
    }

    to {
        margin-left: 0;
    }
}

.table-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
}

.col-1 {
    flex-basis: 20%;
    text-align: left;
}

.col-2 {
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-3 {
    flex-basis: 20%;
    text-align: left;
    margin-left: 5px;
}

.col-4 {
    flex-basis: 20%;
    text-align: left;
    margin-left: 5px;
}

.col-5 {
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.col-data {
    text-align: left;
}

.service-text {
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.active-status {
    background-color: #c7f5d7;
    color: #15763a;
}

.inactive-status {
    background-color: #e0e0e0;
    color: #666666;
}

.shipmentid-text {
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: 0.5s;
}

.shipmentid-text:hover {
    filter: brightness(0.9);
    cursor: pointer;
}

input[type="checkbox"] {
    -webkit-appearance: none;
    appearance: none;
    background-color: #ffffff;
    margin: 0;
    cursor: pointer;
    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    display: grid;
    place-content: center;
    transition-duration: 0.5s;
}

input[type="checkbox"]:hover {
    background-color: #f3f3f3;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(
        14% 44%,
        0 65%,
        50% 100%,
        100% 16%,
        80% 0%,
        43% 62%
    );
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text {
    margin: 0 5px 5px 0;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: 0.5s;
}

.download-csv {
    margin-top: 5px;
}

.print-selected-text:hover {
    filter: brightness(0.9);
    cursor: pointer;
}

.close-label {
    margin-left: auto;
}

.loading-charts {
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text,
    .col-data {
        font-size: 8px;
    }

    .shipmentid-text {
        font-size: 10px;
    }

    .table-header {
        font-size: 10px;
    }
}

@media only screen and (max-width: 1135px) {
    .responsive-table {
        overflow-x: auto;
    }

    .table-header,
    .table-row {
        min-width: 750px;
    }
}
</style>